import React, {
    useState,
} from "react";

import {
    Stack,
    Select,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";
import ReusableInput from "components/Inputs/ReusableInput";
import GradientButton from "components/Buttons/GradientButton";


const AddAssessmentDrawer = ({
    isOpen,
    onClose,
    onSubmit,
}) => {

    const [
        formData,
        setFormData,
    ] = useState({
        title: "",
        description: "",
        pass_mark: 70,
        active: true,
    });


    const handleChange = (e) => {

        const {
            name,
            value,
        } = e.target;

        setFormData(
            (prev) => ({
                ...prev,

                [name]:
                    name === "pass_mark"
                        ? Number(value)
                        : name === "active"
                            ? value === "true"
                            : value,
            })
        );
    };


    const handleSubmit = async () => {

        if (!formData.title.trim()) {
            return;
        }

        await onSubmit(
            formData
        );
    };


    return (

        <ReusableDrawer

            isOpen={isOpen}

            onClose={onClose}

            headerContent={
                <h2>
                    Add Assessment
                </h2>
            }

            bodyContent={

                <Stack spacing={4}>

                    <ReusableInput
                        label="Title"
                        name="title"
                        value={
                            formData.title
                        }
                        onChange={
                            handleChange
                        }
                        placeholder="Enter assessment title"
                        isRequired
                    />

                    <ReusableInput
                        label="Description"
                        name="description"
                        value={
                            formData.description
                        }
                        onChange={
                            handleChange
                        }
                        placeholder="Enter assessment description"
                        type="textarea"
                    />

                    <ReusableInput
                        label="Pass Mark"
                        name="pass_mark"
                        type="number"
                        value={
                            formData.pass_mark
                        }
                        onChange={
                            handleChange
                        }
                    />

                    <Select
                        name="active"
                        value={
                            String(
                                formData.active
                            )
                        }
                        onChange={
                            handleChange
                        }
                    >

                        <option value="true">
                            Active
                        </option>

                        <option value="false">
                            Inactive
                        </option>

                    </Select>

                </Stack>
            }

            footerContent={

                <Stack
                    direction="row"
                    justifyContent="flex-end"
                    spacing={4}
                >

                    <GradientButton
                        width="100px"
                        height="40px"
                        onClick={onClose}
                    >
                        Cancel
                    </GradientButton>

                    <GradientButton
                        width="100px"
                        height="40px"
                        onClick={
                            handleSubmit
                        }
                    >
                        Save
                    </GradientButton>

                </Stack>
            }
        />
    );
};


export default AddAssessmentDrawer;